// Approximate regional daylight, calculated locally without location/network APIs.
// Solar equations: NOAA General Solar Position Calculations (public-domain US work).
// https://gml.noaa.gov/grad/solcalc/solareqns.PDF
// These fixed reference coordinates describe regions, never the user's location.
const REGIONS = {
  'Asia/Kolkata':[22.6,79], 'Asia/Calcutta':[22.6,79],
  'Europe/Berlin':[52.52,13.41], 'Europe/Busingen':[52.52,13.41],
  'Europe/Vienna':[48.21,16.37], 'Europe/Zurich':[47.38,8.54],
  'Europe/Paris':[48.86,2.35], 'Europe/Brussels':[50.85,4.35],
  'Europe/Amsterdam':[52.37,4.9], 'Europe/Luxembourg':[49.61,6.13],
  'Europe/Rome':[41.9,12.5], 'Europe/Vatican':[41.9,12.5], 'Europe/San_Marino':[41.9,12.5],
  'Europe/Madrid':[40.42,-3.7], 'Atlantic/Canary':[28.1,-15.4],
  'Europe/Lisbon':[38.72,-9.14], 'Atlantic/Madeira':[32.65,-16.91], 'Atlantic/Azores':[37.74,-25.67],
  'Europe/Athens':[37.98,23.73], 'Europe/Malta':[35.9,14.51],
  'Asia/Nicosia':[35.19,33.38], 'Europe/Nicosia':[35.19,33.38], 'Asia/Famagusta':[35.19,33.38],
  'Europe/Prague':[50.08,14.44], 'Europe/Bratislava':[48.15,17.11],
  'Europe/Warsaw':[52.23,21.01], 'Europe/Budapest':[47.5,19.04],
  'Europe/Ljubljana':[46.06,14.51], 'Europe/Zagreb':[45.81,15.98],
  'Europe/Sarajevo':[43.86,18.41], 'Europe/Belgrade':[44.81,20.46],
  'Europe/Podgorica':[42.44,19.26], 'Europe/Skopje':[42,21.43],
  'Europe/Tirane':[41.33,19.82], 'Europe/Sofia':[42.7,23.32],
  'Europe/Bucharest':[44.43,26.1], 'Europe/Chisinau':[47.01,28.86],
  'Europe/Kyiv':[50.45,30.52], 'Europe/Kiev':[50.45,30.52],
  'Europe/Istanbul':[41.01,28.98], 'Asia/Istanbul':[41.01,28.98],
  'Europe/London':[51.51,-.13], 'Europe/Dublin':[53.35,-6.26],
  'Europe/Gibraltar':[36.14,-5.35], 'Europe/Andorra':[42.51,1.52], 'Europe/Monaco':[43.74,7.42],
};
const rad=Math.PI/180;
export function deviceTimeZone(){
  try{return Intl.DateTimeFormat().resolvedOptions().timeZone||'';}catch{return '';}
}
export function automaticAppearanceAt(date=new Date(),timeZone=deviceTimeZone()){
  const region=REGIONS[timeZone];
  if(!region){
    const hour=date.getHours();
    return {theme:hour>=7&&hour<19?'light':'dark',basis:'clock'};
  }
  const year=date.getUTCFullYear(),start=Date.UTC(year,0,1);
  const days=(Date.UTC(year+1,0,1)-start)/86400000;
  const day=Math.floor((date.getTime()-start)/86400000);
  const hour=date.getUTCHours()+date.getUTCMinutes()/60+date.getUTCSeconds()/3600;
  const gamma=2*Math.PI/days*(day+(hour-12)/24);
  const eqtime=229.18*(.000075+.001868*Math.cos(gamma)-.032077*Math.sin(gamma)-.014615*Math.cos(2*gamma)-.040849*Math.sin(2*gamma));
  const decl=.006918-.399912*Math.cos(gamma)+.070257*Math.sin(gamma)-.006758*Math.cos(2*gamma)+.000907*Math.sin(2*gamma)-.002697*Math.cos(3*gamma)+.00148*Math.sin(3*gamma);
  const [lat,lon]=region;
  const solarMinutes=((hour*60+eqtime+4*lon)%1440+1440)%1440;
  const angle=(solarMinutes/4-180)*rad;
  const zenithCos=Math.sin(lat*rad)*Math.sin(decl)+Math.cos(lat*rad)*Math.cos(decl)*Math.cos(angle);
  return {theme:zenithCos>=Math.cos(90.833*rad)?'light':'dark',basis:'solar'};
}
